<template>
  <v-container fluid>
    <v-card class="card-rounded">
      <v-form lazy-validation>
        <v-card-title>
          <span class="headline">Estatisticas</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
            @click="incluir()"
            >Incluir</v-btn
          >
            <v-row>
              <v-data-table
                :key="dtbKey"
                :headers="headers"
                :items="estatisticas"
                :items-per-page="10"
                :loading="loading"
                :no-data-text="
                  loading ? 'Carregando' : 'Nenhum Registro para mostrar'
                "
                class="elevation-1"
              >

                <template v-slot:[`item.edit`]="{ item }">
                  <v-icon small @click="onEdit(item)">edit</v-icon>
                </template>
                <template v-slot:[`item.data`]="{ item }">
                  <span>{{ formatDate(item.data) }}</span>
                </template>
                <template v-slot:[`item.tipo`]="{ item }">
                  <span>{{ item.tipo == "E" ? "Entrada" : "Saída" }}</span>
                </template>
              </v-data-table>
            </v-row>
          </v-container>
          <concurso-estatisticas 
            :editData="editData" 
            :openEstatisticas="openEstatisticas" 
            @onSaveEstatistica="onSaveEstatistica"
            @onCancelEstatistica="onCancelEstatistica"></concurso-estatisticas>
        </v-card-text>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import ConcursoEstatisticas from "../../views/concursos/ConcursoEstatisticas.vue";

export default {
  components: {
    "concurso-estatisticas": ConcursoEstatisticas,
  },
  data() {
    return {
      dtbKey: 0,
      openEstatisticas: false,
      editData: null,
      headers: [
        { text: 'Editar', align: 'center', sortable: false, value: 'edit'},
        {
          text: "Impar",
          align: "left",
          sortable: true,
          value: "impar",
        },
        {
          text: "Par",
          align: "left",
          sortable: true,
          value: "par",
        },
        {
          text: "Primo",
          align: "left",
          sortable: true,
          value: "primo",
        },
        {
          text: "Frequência",
          align: "left",
          sortable: true,
          value: "frequencia",
        },
        {
          text: "Atraso",
          align: "left",
          sortable: true,
          value: "atraso",
        },
        {
          text: "Tendência",
          align: "left",
          sortable: true,
          value: "tendencia",
        },
      ],
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      estatisticas: "estatisticas",
    }),
  },
  created() {
    this.getDados();
  },

  methods: {
    incluir() {
      this.editData = null
      this.openEstatisticas = true
    },
    onCancelEstatistica(){
      this.openEstatisticas = false
    },
    onSaveEstatistica() {
      this.openEstatisticas = false
      this.getDados();
    },
    onEdit(value) {
      this.editData = value
      this.openEstatisticas = true
    },
    getDados() {
      this.loading = true;
      this.$store
        .dispatch("findEstatisticas")
        .then((value) => {
          this.dtbKey += 1;
        })
        .catch((err) => {
          this.$store.dispatch("setNotification", {
            type: "error",
            text: "Ouve um erro ao consultar os registros de estatisticas",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
